<template>
  <div class="example">I'm a box with a border-radius</div>
</template>

<style lang="scss" scoped>
.example {
  width: fit-content;
  border: 2px solid var(--clr-primary);
  color: var(--clr-primary);
  padding: 7rem;
  text-align: center;
  transition: var(--transition-duration) var(--transition-timing-function);
}
</style>
